import styled, { keyframes } from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { PixelPlaceholderLoader } from "@similarweb/ui-components";

const containerSegmentAnimation = keyframes`
  0% {
    opacity: 0;
  }
  35% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const SegmentPageResultsContainer = styled.div<{
    showTooLongSegmentRulesErrorText?: boolean;
}>`
    flex: auto;
    overflow: hidden;
    background-color: ${colorsPalettes.carbon[0]};
    padding: 0;
    position: relative;
    width: 360px;
    height: 100%;
    display: flex;
    flex-direction: column;
    animation: ${containerSegmentAnimation} ease-in-out 1000ms;
    ${({ showTooLongSegmentRulesErrorText }) =>
        showTooLongSegmentRulesErrorText
            ? `
                  justify-content: center;
                  align-items: center;
                  margin-bottom: 160px;
              `
            : ""};

    @media screen and (max-width: 1280px) {
        width: 100%;
    }
`;

export const LoaderContainer = styled(FlexColumn)`
    padding-top: 30px;
    align-items: center;
`;

export const PixelPlaceholderLoaderStyled = styled(PixelPlaceholderLoader)`
    padding-top: 16px;
`;

export const HourGlassContainer = styled(FlexColumn)<{ isVisible: boolean }>`
    margin-top: 180px;
    position: absolute;
    visibility: ${({ isVisible }) => (isVisible ? "visible" : "hidden")};
    width: 248px;
    height: 248px;
    border-radius: 50%;
    background-color: ${colorsPalettes.carbon[0]};
    z-index: 999;
    align-items: center;
    justify-content: center;
`;

export const HourGlassImg = styled.img`
    width: 77px;
    height: 75px;
`;

export const SegmentsUrlMainText = styled.div`
    font-size: 16px;
    font-weight: 500;
    text-align: center;
    line-height: 20px;
    color: ${colorsPalettes.carbon[300]};
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 3;
`;

export const SegmentsUrlMainContainer = styled(FlexColumn)`
    height: 100%;
    justify-content: center;
    align-items: center;
`;

export const TooLongSegmentRulesErrorStateStyle = styled.div`
    width: 200px;
    ${setFontVariant("subtitle1", colorsPalettes.red["s100"])};
    text-align: center;
`;
